import _ from 'lodash'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PublicFormContext from '../../contexts/PublicFormContext'
import { flattenEntity } from '../../helpers/entity'
import { sanitiseFilterString } from '../../libraries/sanitiseFilterString'

//actions
import entityActions, { getReduxKey } from '../../store/entity/actions'
import { evaluateRule } from '../query/evaluateRule'

import CheckboxMultiselectWithData from './CheckboxMultiselectWithData'
import { useDiscoverEntityEntityType } from '../../hooks/useDiscoverEntityEntityType'
import { sortListWithEntityType } from '../../libraries/entityTools'
import {
  getAvailableFilters,
  simplifyFilters
} from '../../screens/EntityListScreen'

export const CheckboxMultiselect = (props) => {
  const dispatch = useDispatch()

  const [nextUnfetchedPage, setNextUnfetchedPage] = useState(1)
  const publicFormContext = useContext(PublicFormContext)

  const sourceNames = useMemo(() => {
    return _.castArray(props.data.field.field_data.params.sourceName)
  }, [props.data.field.field_data.params.sourceName])
  const sourceName = sourceNames[0]

  const { entityType } = useDiscoverEntityEntityType(
    null,
    null,
    sourceName,
    null,
    false
  )

  const [serverFilter, setServerFilter] = useState(
    props.data?.field?.field_data?.params?.serverFilter
  )

  useEffect(() => {
    const availableFilters = getAvailableFilters(entityType)
    const newServerFilter = entityType?.object_data?.filters_selected
      ? simplifyFilters(
          {},
          entityType?.object_data?.filters_selected,
          availableFilters
        )
      : props.data?.field?.field_data?.params?.serverFilter
    setServerFilter(newServerFilter)
  }, [entityType])

  const filterRule =
    props?.data?.field?.field_data?.params?.optionsFilter?.json?.logic

  const filter = filterRule
    ? {
        detailed: true
      }
    : null

  const reduxKey = sanitiseFilterString(
    getReduxKey(serverFilter, { detailed: true })
  )
  const path = `${sourceName + reduxKey}`

  const entityListWrapper = useSelector((state) => {
    const entityListWrapper = sourceName
      ? state.entities[path] ?? {
          data: null,
          meta: null,
          hasSeenData: false
        }
      : { data: null, meta: null, hasSeenData: false }

    entityListWrapper.data = sortListWithEntityType(
      entityListWrapper.data,
      entityType
    )
    return entityListWrapper
  })

  const fetchNextPage = (index, forcePage = null) => {
    let pageToFetch

    if (forcePage !== null) {
      pageToFetch = forcePage
    }

    dispatch(
      entityActions.listEntity(
        { name: sourceNames[index] },
        {
          filter: {
            ...filter,
            ...serverFilter
          },
          page: pageToFetch,
          detailed: filter?.detailed
        },
        undefined,
        publicFormContext.entityType,
        {
          tenantId: publicFormContext.tenantId,
          tenantHmac: publicFormContext.tenantHmac
        }
      )
    ).then((response) => {
      // stop at 10.
      if (
        response.meta.current_page < response.meta.last_page &&
        response.meta.current_page < 10
      ) {
        setNextUnfetchedPage(response.meta.current_page + 1)
      } else {
        setNextUnfetchedPage(-1)
      }

      return response
    })
  }

  useEffect(() => {
    if (entityType && nextUnfetchedPage !== -1) {
      fetchNextPage(0, nextUnfetchedPage)
    }
  }, [nextUnfetchedPage, entityType, serverFilter])

  const sourceData = useMemo(() => {
    const data = _.flatten(entityListWrapper.data)
    const filteredData = filterRule
      ? data.filter((d) =>
          evaluateRule(filterRule, {
            ...flattenEntity(d, false),
            field: flattenEntity(props.data.entity, false)
          })
        )
      : data

    return filteredData
  }, [entityListWrapper])

  return (
    <CheckboxMultiselectWithData
      {...props}
      dataRows={sourceData}
      labelField={'display_name'}
      value={props.defaultValue}
    />
  )
}
